import { Paper, Wizard } from '@driftt/dds'
import React from 'react'

import FormSubmissionImage from './FormSubmission.svg'
import URLPreviewImage from './URLPreview.svg'

const FLCreationWizardStepSidePanelVariant = {
  formSubmission: (
    <img
      src={FormSubmissionImage}
      alt="Preview graphic of Fastlane form submission triggering Fastlane chat experience"
    />
  ),
  urlWindow: (
    <Paper elevation={4}>
      <img
        src={URLPreviewImage}
        alt="Infographic display URL location in browser window"
      />
    </Paper>
  ),
} as const

interface FLCreationWizardStepSidePanelProps {
  variant: keyof typeof FLCreationWizardStepSidePanelVariant
}

export const FLCreationWizardStepSidePanel = ({
  variant,
}: FLCreationWizardStepSidePanelProps) => {
  const svgToDisplay = FLCreationWizardStepSidePanelVariant[variant]

  return (
    <Wizard.StepColumn
      css={{
        height: '100%',
        backgroundColor: '$blue1',
        '& > img': {
          maxWidth: '80%',
        },
      }}
      fullWidth
      alignItems="center"
      justifyContent="center"
    >
      {svgToDisplay}
    </Wizard.StepColumn>
  )
}
